<template>
    <div class="content" v-if="masechet">
        <div class="header">{{l10nMasechet}} {{masechet.name}}</div>
        <div class="sub-header">{{masechet.description}}</div>
        <div class="divider"></div>
        <div class="sub-header-sponsor" v-if="masechet.sponsor">
            <span>{{l10nMasechetSponsor}}: </span>
            <span>{{masechet.sponsor.name}}</span>
            <span class="spacer"></span>
            <span class="hebrew">{{masechet.sponsor.reason}}: </span>
            <span>{{masechet.sponsor['dedication_name']}}</span>
        </div>
        <div class="sub-categories-content">
            <div class="shiurim-list">
                <template v-if="readyToDisplayList">
                    <div v-for="(lesson, index) in shiurim.data" class="shiur-row" :key="index">
                        <div class="action-section" v-on:click="navigateToLesson(lesson)">
                            <div class="play-section">
                                <img src="../assets/icons/play-icon-2x.png" alt="" class="play-icon">
                            </div>
                            <div class="info-section">
                                <div class="shiur-title-section">{{lesson.name}}</div>
                                <div class="shiur-length-section">
                                    <font-awesome-icon class="shiur-length-icon" :icon="['fal', 'clock']"/>
                                    {{lesson.video ? lesson.video.duration : NaN | duration}}
                                </div>
                            </div>
                        </div>
                        <div class="non-action-section">
                            <div class="save-section">
                                <div class="save-to-favorites-section" v-on:click="onSaveToFavoritesClick(index)"
                                     :class="saveSectionClassObj(index)"
                                     @mouseenter="onSaveToFavoritesMouseEnter($event, index)"
                                     @mouseleave="onSaveToFavoritesMouseExit($event, index)">
                                    <font-awesome-icon class="save-section-icon"
                                                       :icon="[getIconPrefix(index), 'star']"/>
                                    <span>{{saveToFavoritesText(index)}}</span>
                                </div>
                            </div>
                            <div class="download-section">
                                <jabra-download-section :lesson="lesson"></jabra-download-section>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="shiur-row">
                        <div class="action-section">
                            <div class="play-section">
                                <font-awesome-icon class="play-icon" :icon="['fal', 'play-circle']" size="3x"/>
                            </div>
                            <div class="info-section">
                                <div class="shiur-title-section">{{l10nLoading}}</div>
                                <div class="shiur-length-section">
                                    <font-awesome-icon class="shiur-length-icon" :icon="['fal', 'clock']"/>
                                    {{l10nLoading}}
                                </div>
                            </div>
                        </div>
                        <div class="save-section">
                            <div class="save-to-favorites-section">
                                <font-awesome-icon class="save-section-icon" :icon="['fal', 'star']"/>
                                <span>{{l10nSaveToFavorites}}</span>
                            </div>
                        </div>
                        <div class="download-section">
                            <jabra-download-section></jabra-download-section>
                        </div>
                    </div>
                </template>

            </div>
            <div class="sedarim-dropdown-container">
                <div class="sedarim-dropdown">
                    <div v-for="(seder, index) in sedarim" v-bind:key="seder.id">
                        <div class="expansion-section">
                            <div class="seder-section"
                                 v-bind:style="{'border-left-color': seder.color}"
                                 v-on:click="setDropdownIndex(index)">
                                <span>{{seder.name}}</span>
                                <font-awesome-icon :icon="['fal', 'angle-down']"/>
                            </div>
                            <transition-expand>
                                <div class="masechtot-list" v-if="selectedDropdownIndex === index">
                                    <div v-for="masechet in filterMasechtotBySeder(seder)" class="masechet-item"
                                         v-on:click="navigateToSubComponent(masechet)" v-bind:key="masechet.id">
                                        {{masechet.name}}
                                    </div>
                                </div>
                            </transition-expand>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../services/axios'
    import helpers from '../services/helpers'
    import TransitionExpand from './transitional/TransitionExpand'
    import vanilla from '../services/vanilla'

    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        ADD_USER_EVENT,
        ACTION_FAVORITE,
        GET_USER_FAVORITES,
        SET_SIGNUP_SHOW_STATE,
    } from '../services/constants'

    export default {
        name: 'sub-categories-component',
        components: {
            'transition-expand': TransitionExpand
        },
        data: function () {
            return {
                masechet: null,
                shiurim: {
                    state: LOADING_PRISTINE,
                    data: [],
                    error: null,
                },
                selectedDropdownIndex: -1,
                LOADING_PRISTINE: LOADING_PRISTINE,
                LOADING_STARTED: LOADING_STARTED,
                LOADING_COMPLETED_SUCCESS: LOADING_COMPLETED_SUCCESS,
                LOADING_COMPLETED_FAILURE: LOADING_COMPLETED_FAILURE,
                hoverIndex: -1
            }
        },
        computed: {
            sedarim: function () {
                return this.$store.state.sedarim.data
            },
            masechtot: function () {
                return this.$store.state.masechtot.data
            },
            user: function () {
                return this.$store.state.user.data
            },
            areEventsLoadedSuccessfully() {
                return this.$store.state.userModule.events.state === LOADING_COMPLETED_SUCCESS
            },
            favoriteEvents() {
                return this.$store.getters[GET_USER_FAVORITES]
            },
            l10nMasechet() {
                return this.l10nGetter('masechet')
            },
            l10nMasechetSponsor() {
                return this.l10nGetter('masechet_sponsor')
            },
            l10nSaveToFavorites() {
                return this.l10nGetter('save_to_favorites')
            },
            l10nSavedToFavorites() {
                return this.l10nGetter('saved_to_favorites')
            },
            l10nDownload() {
                return this.l10nGetter('download')
            },
            l10nLoading() {
                return this.l10nGetter('loading')
            },
            readyToDisplayList() {
                if (this.user) {
                    return this.shiurim.state === LOADING_COMPLETED_SUCCESS && this.areEventsLoadedSuccessfully
                }
                return this.shiurim.state === LOADING_COMPLETED_SUCCESS
            },
            masechetIdFromRoute() {
                return Number(this.$route.params['id'])
            }
        },
        watch: {
            masechtot(newValue) {
                this.update()
            },
            sedarim(newValue) {
                this.update()
            },
            '$route'(to, from) {
                this.update()
            },
        },
        methods: {
            setDropdownIndex: function (sederIndex) {
                this.selectedDropdownIndex === sederIndex ? this.selectedDropdownIndex = -1 :
                    this.selectedDropdownIndex = sederIndex
            },
            navigateToSubComponent: function (masechet) {
                this.$router.push({name: 'subcategory', params: {id: masechet.id.toString()}})
            },
            navigateToLesson: function (lesson) {
                this.$router.push({name: 'lesson', params: {id: lesson.id.toString()}})
            },
            filterMasechtotBySeder: function (seder) {
                return this.masechtot.filter(masechet => {
                    return masechet.seder.id === seder.id
                })
            },
            update() {
                this.setDropdownIndex(-1)
                if (this.masechtot && this.sedarim) {
                    this.masechet = this.masechtot.find(masechet => {
                        return masechet.id === this.masechetIdFromRoute
                    })
                    if (this.masechet) {
                        const i = this.sedarim.findIndex(seder => {
                            return seder.id === this.masechet.seder.id
                        })

                        if (i > -1) {
                            this.setDropdownIndex(i)
                        }
                        if (this.masechet && this.masechet.name) {
                            vanilla.setDocumentTitle(`Jabrutouch - ${this.masechet.name}`)
                        }

                        this.getLessons()
                    }
                }
            },
            getLessons() {
                this.shiurim = {
                    state: LOADING_STARTED,
                    data: [],
                    error: null,
                };
                const config = {
                    params: {
                        masechet: this.masechet.id,
                        language: this.$store.state.languageModule.currentLanguage.locale
                    }
                }
                http.getDelivery(`entries?contentType=lesson`, config).then(results => {
                    const mappedResults = results.data.map(entry => {
                        return helpers.mapEntry(entry)
                    })
                    mappedResults.sort(helpers.sortEntriesByFactory('number'))
                    this.shiurim = {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResults,
                        error: null,
                    };
                }).catch(err => {
                    console.log(err)
                    this.shiurim = {
                        state: LOADING_COMPLETED_FAILURE,
                        data: [],
                        error: err.message,
                    };
                })
            },
            onSaveToFavoritesClick(index) {
                if (!this.user) {
                    this.$store.commit(SET_SIGNUP_SHOW_STATE, true)
                } else {
                    if (!this.isShiurFavorite(index))
                        this.$store.dispatch(ADD_USER_EVENT, {
                            userID: this.user.id,
                            action: ACTION_FAVORITE,
                            entryID: this.shiurim.data[index].id,
                        });
                }
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            onSaveToFavoritesMouseEnter(evt, index) {
                this.setHoverIndex(index)
            },
            onSaveToFavoritesMouseExit(evt, index) {
                this.unsetHoverIndex()
            },
            setHoverIndex(index) {
                this.hoverIndex = index
            },
            unsetHoverIndex() {
                this.hoverIndex = -1
            },
            isShiurFavorite(index) {
                return this.favoriteEvents.some(event => {
                    return event.entryID === this.shiurim.data[index].id
                })
            },
            getIconPrefix(index) {
                return index === this.hoverIndex || this.isShiurFavorite(index) ? 'fas' : 'fal'
            },
            saveSectionClassObj(index) {
                return {'favorite': this.isShiurFavorite(index)}
            },
            saveToFavoritesText(index) {
                return this.isShiurFavorite(index) ? this.l10nSavedToFavorites : this.l10nSaveToFavorites
            }
        },
        created: function () {
            this.update()
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        background: $background-color-grey;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 0 130px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .sub-header {
        @include font-abraham(36px, $font-color-blue, 300);
    }

    .sub-header-sponsor {
        @include font-abraham(26px, $font-color-lighter-blue, 300);
        .spacer {
            width: 12px;
            display: inline-block;
        }
        .hebrew {
            line-height: 48px;
        }
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .sub-categories-content {
        display: flex;
        margin: 48px 0 0 0;
    }

    .shiur-row {
        display: flex;
        justify-content: space-between;
        border-top: $grey-3 solid 1px;
        padding: 20px 14px;

        &:hover {
            background: white;
            .play-icon, .shiur-title-section {
                color: $accent-1;
            }
        }
    }

    .action-section {
        cursor: pointer;
        display: flex;
        padding: 0 50px 0 0;
    }

    .play-icon {
        $play-icon-size: 48px;
        color: $font-color-blue;
        margin: 0 30px 0 0;
        height: $play-icon-size;
        width: $play-icon-size;
    }

    .shiur-title-section {
        @include font-abraham(26px, $font-color-blue, 400);
    }

    .shiur-length-section {
        display: flex;
        align-items: center;
        @include font-abraham(18px, $grey-1, 300);
    }

    .shiur-length-icon {
        margin: 0 12px 0 0;
    }

    .non-action-section {
        display: flex;
    }

    .save-section {
        display: flex;
        align-items: center;
        @include font-abraham(14px, $font-color-lighter-blue, 300);
        line-height: 16px;
        border-left: $grey-3 solid 1px;
        border-right: $grey-3 solid 1px;

    }

    .save-to-favorites-section {
        cursor: pointer;
        min-width: 141px;
        &:hover {
            color: $accent-1;
        }
        &.favorite {
            color: $accent-1;
        }
        margin: 0 30px;
        span {
            margin: 6px;

        }
        display: flex;
    }

    .save-section-icon {
        font-size: 24px;
    }

    .download-section {
        display: flex;
        align-items: center;
        padding: 0 7px 0 24px;
    }

    $seder-non-hover-color: rgba(220, 233, 239, 0.4);

    .sedarim-dropdown {
        margin: 0 0 0 30px;
        box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.17);
    }

    .seder-section {
        cursor: pointer;
        background: $seder-non-hover-color;
        @include font-abraham(24px, $font-color-blue, 400);
        text-transform: uppercase;
        border-left-style: solid;
        border-left-width: 5px;
        padding: 20px 20px 20px 35px;
        display: flex;
        justify-content: space-between;
        min-width: 340px;
        @media (max-width: 1200px) {
            min-width: 240px;
        }
    }

    .masechet-item {
        cursor: pointer;
        @include font-abraham(20px, $grey-2, 400);
        line-height: 28px;
        background: white;
        padding: 22px 0 22px 77px;
        border-bottom: $grey-3 solid .5px;
    }

    .seder-section-divider {
        border-bottom: white solid 3px;
    }

</style>
